import { getSingleParam } from 'x1-base/utils';

export function useExtPayment() {
    const router = useRouter();
    const isRedirect = ref<Nullable<boolean>>(null);
    const stripeSecret = ref<Nullable<string>>(null);

    const params = [
        'payment_intent',
        'payment_intent_client_secret',
        'redirect_status'
    ] as const;

    onBeforeMount(() => {
        const { query } = router.currentRoute.value;
        const paymentIntent = getSingleParam(query, params[0]);
        const secret = getSingleParam(query, params[1]);

        if (paymentIntent && secret) {
            isRedirect.value = true;
            stripeSecret.value = secret;
        } else {
            isRedirect.value = false;
        }
    });

    function clearParams() {
        if (import.meta.client) {
            try {
                const url = new URL(window.location.href);
                url.hash = '';
                params.forEach(p => url.searchParams.delete(p));
                window.history.replaceState({}, '', url.href);
                
            } catch (err) {}
        }
    }

    return {
        isRedirect,
        stripeSecret,
        clearParams
    };
}
